/* Bastion Collective — wire DC email-capture forms to Shopify native newsletter.
   Heuristic: a form with exactly one email input and no other text/select/textarea
   fields is a newsletter/notify form. Posts to /contact as form_type=customer so
   subscribers land in THIS store's Customers (tagged), not any external ESP. */
(function () {
  function isNewsletter(f) {
    var emails = f.querySelectorAll('input[type="email"]');
    var others = f.querySelectorAll(
      'input:not([type="email"]):not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select'
    );
    return emails.length === 1 && others.length === 0 ? emails[0] : null;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var emailEl = isNewsletter(f);
    if (!emailEl) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var email = (emailEl.value || '').trim();
    if (!email) { emailEl.focus(); return; }
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter,bastion-site');
    var original = emailEl.getAttribute('placeholder') || '';
    emailEl.value = '';
    emailEl.setAttribute('placeholder', 'Adding you…');
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: body.toString()
    }).then(function () {
      emailEl.setAttribute('placeholder', 'Thank you — you are on the list.');
    }).catch(function () {
      emailEl.setAttribute('placeholder', original || 'Try again');
    });
  }, true);
})();
